import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MetaTags } from "react-meta-tags";
import { useTranslation } from "react-i18next";
import { Container, Row } from "reactstrap";
import RequestBonus from "./RequestBonus";
import { fetchBonus } from "store/forex/bonus/actions";
import { getAccountsStart } from "store/forex/accounts/actions";
import CardWrapper from "components/Common/CardWrapper";

function Bonus() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const bonusDetails = useSelector((state)=> state.bonusReducer.docs);
  const { accounts } = useSelector((state) => state.forex?.accounts);
  useEffect(() => {
    loadData();
  }, []);


  const result = bonusDetails?.filter((bonus)=> bonus.isPublic === true);
  const finalResult = accounts?.map((a)=>{
    let trade = result?.map((s)=>{
      if (a.accountTypeId?._id === s.accountType) {
        return s;
      }
    });

    trade = trade?.filter((item) => item !== undefined );
    return trade;  
  });
  console.log("finalResult", finalResult);

  const flattenedResult = finalResult?.flat();
  const uniqueFlattenedResult = Array.from(new Set(flattenedResult));
  console.log("uniqueFlattenedResult", uniqueFlattenedResult);
  const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const todayDate = startOfDay(new Date());

  const validatedResult = uniqueFlattenedResult?.filter((bonus) => {
    const dateTo = bonus?.dateTo ? startOfDay(new Date(bonus.dateTo)) : null;
    const dateFrom = bonus?.dateFrom ? startOfDay(new Date(bonus.dateFrom)) : null;
  
    const dateToValid = dateTo == null || dateTo >= todayDate;
    const dateFromValid = dateFrom == null || dateFrom <= todayDate;
  
    return dateToValid && dateFromValid;
  });
  // const finalValidatedResult = validatedResult.filter((bonus) => bonus?.isPublic == true);
  function loadData(){
    dispatch(getAccountsStart());
    dispatch(fetchBonus());
  }
  return (
    <>
      <MetaTags>
        <title>{t("Bonus")}</title>
      </MetaTags>
      <div className="page-content text-center">
        <Container className="mt-1">
          <CardWrapper className="p-4 glass-card shadow-lg my-5">
            <div className="d-flex justify-content-center mb-3 mt-3">
              <h1 className="color-primary">Bonus</h1>
            </div>
            <Row className="mt-1 g-4">
              { validatedResult ?.map((bonus, indx) => <RequestBonus key={indx}
                bonusDetails={bonus}
              />) }
            </Row>
          </CardWrapper>
        </Container>
      </div>
    </>
  );
}

export default Bonus;